import {
  COOKIE_CONSENT_KEY,
  COOKIE_CONSENT_OPTIONS,
  normalizeCookieConsent,
  type CookieConsentValue,
} from "~/utils/privacyConsent";
import posthog from "posthog-js";
import { createPostHogConsentController } from "~/utils/posthogConsent";

export default defineNuxtPlugin({
  name: "posthog-consent",
  setup() {
    const cookieConsent = useCookie<CookieConsentValue>(
      COOKIE_CONSENT_KEY,
      COOKIE_CONSENT_OPTIONS,
    );
    const hasConsent = () => {
      // Read the cookie at capture time as well: useCookie can outlive its expiry.
      const value = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith(`${COOKIE_CONSENT_KEY}=`))
        ?.split("=")
        .slice(1)
        .join("=");
      try {
        const decoded = decodeURIComponent(value ?? "");
        return (
          normalizeCookieConsent(
            decoded === "accepted" ? decoded : JSON.parse(decoded),
          )?.analytics === true
        );
      } catch {
        return false;
      }
    };
    let storage: Storage | undefined;
    try {
      storage = localStorage;
    } catch {
      /* Browser storage can be disabled. */
    }
    const controller = createPostHogConsentController(
      posthog,
      useRuntimeConfig().public.posthog,
      hasConsent,
      storage,
      window.location.href,
      document.referrer,
    );
    watch(cookieConsent, controller.sync, { immediate: true, flush: "post" });
    return {
      provide: {
        posthog: controller.client,
        syncPostHogConsent: controller.sync,
      },
    };
  },
});
